/**
 * ContentStateSymbol.js
 *
 * Enumerates all states of the content FSM.
 *
 * Copyright (c) apploft. GmbH
 */

const ready = Symbol('initialized and ready');
const presentingList = Symbol('presenting a list of items');
const presentingForm = Symbol('presenting a form');
const presentingEditingForm = Symbol('presenting a form for editing an item');
const fetchingItem = Symbol('fetching a single item for editing');
const fetchingItems = Symbol('fetching items for showing in a list');
const submittingForm = Symbol('submitting a form');

export {
  ready,
  presentingForm,
  presentingList,
  fetchingItems,
  submittingForm,
  presentingEditingForm,
  fetchingItem,
};
